import { IconArrowDownRight, IconArrowUpRight } from '@sloyd/icons';
import { Group, Paper, SimpleGrid, Text, ThemeIcon } from '@sloyd/ui';
import classes from './Stats.module.css';
import { Wrapper } from './Stats.style';

const data = [
  { title: 'Generators', value: '1,049', diff: 34 },
  { title: 'Creators', value: '85K', diff: 13 },
  { title: 'AI Textures', value: '17,145', diff: 18 },
  { title: 'AI Benchmark', value: '1,429', diff: 18 },
];

export type StatsProps = {};

export function Stats(_props: StatsProps) {
  const stats = data.map((stat) => {
    const DiffIcon = stat.diff > 0 ? IconArrowUpRight : IconArrowDownRight;

    return (
      <Paper withBorder p='md' radius='md' key={stat.title}>
        <Group justify='apart'>
          <div>
            <Text c='dimmed' tt='uppercase' fw={700} fz='xs' className={classes.label}>
              {stat.title}
            </Text>
            <Text fw={700} fz='xl'>
              {stat.value}
            </Text>
          </div>
          <ThemeIcon
            color='gray'
            variant='light'
            style={{
              color: stat.diff > 0 ? 'var(--mantine-color-teal-6)' : 'var(--mantine-color-red-6)',
            }}
            size={38}
            radius='md'
          >
            <DiffIcon size={28} stroke={1.5} />
          </ThemeIcon>
        </Group>
        <Text c='dimmed' fz='sm' mt='md'>
          <Text component='span' c={stat.diff > 0 ? 'teal' : 'red'} fw={700}>
            {stat.diff}%
          </Text>{' '}
          {stat.diff > 0 ? 'increase' : 'decrease'} compared to last month
        </Text>
      </Paper>
    );
  });

  return (
    <Wrapper className='Stats-wrapper' data-testid='Stats-wrapper'>
      <div className={classes.root}>
        <SimpleGrid cols={{ base: 1, sm: 6 }}>{stats}</SimpleGrid>
      </div>
    </Wrapper>
  );
}

export default Stats;
